__turbopack_context__.v({
  "navButton": "style-module-scss-module__tAFo5G__navButton",
  "navigation": "style-module-scss-module__tAFo5G__navigation",
});
